// API Configuration using environment variables
const getApiBaseUrl = () => {
  // Use environment variable if available, otherwise fallback to localhost
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
};

// Update environment files for the new domain
// .env.development should have: VITE_API_BASE_URL=https://dev.api.canadawaleyar.com
// .env.production should have: VITE_API_BASE_URL=https://api.canadawaleyar.com

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  SLOTS: `${API_BASE_URL}/api/appointment/slots`,
  CREATE_BOOKING: `${API_BASE_URL}/api/appointment/create`,
  SEARCH_CLIENTS: `${API_BASE_URL}/api/appointment/clients/search`,
  HEALTH: `${API_BASE_URL}/health`, // Add health check endpoint
  STRIPE_CHECKOUT: `${API_BASE_URL}/api/stripe/request`,
  STRIPE_STATUS: (sessionId: string) => `${API_BASE_URL}/api/stripe/status/${sessionId}`,
  AVAILABILITY: `${API_BASE_URL}/api/availability`, // Get availability/unavailability data
  COUPON_VALIDATE: `${API_BASE_URL}/api/coupons/validate`,
  COUPON_APPLY: `${API_BASE_URL}/api/coupons/apply`,
  APPOINTMENT_TAKERS: `${API_BASE_URL}/api/appointment/takers/booking`,
  APPOINTMENT_TAKER_BY_SLUG: (slug: string) => `${API_BASE_URL}/api/appointment/takers/slug/${slug}`,
};

// Debug function to test API connectivity
export const testApiConnection = async () => {
  try {
    console.log('Testing API connection to:', API_BASE_URL);
    const response = await fetch(API_ENDPOINTS.HEALTH);
    const data = await response.json();
    console.log('API Health Check Response:', data);
    return data;
  } catch (error) {
    console.error('API Connection Test Failed:', error);
    return null;
  }
}; 